import fdDataTable from '../../../js/app/dataTable/fdDataTable';

export default {
    data() {
        return {
            // 法院公告的tab数据
            fyggList: fdDataTable.fyggList,
            // activeFygg: {
            //     name: '送达',
            //     code: '6'
            // },
            activeFygg: {
                name: '开庭',
                code: '7'
            },
            // 法院介绍的tab数据
            fyjsList: fdDataTable.fyjsList,
            fyjsActive: {
                name: '最高人民法院',
                code: '0'
            },
            // 扣押的tab数据
            kyList: fdDataTable.kyList,
            kyActive: {
                name: '船舶扣押',
                code: 'cbky'
            },
            // 拍卖的tab数据
            pmList: fdDataTable.pmList,
            pmActive: {
                name: '其他拍卖',
                code: 'qtpm'
            },
            // 海事案例的tab切换
            hsalList: fdDataTable.hsalList,
            hsalActive:{
                name: '指导性案例',
                code: '0'
            },
            // 理论探讨的tab切换
            llttList: fdDataTable.llttList,
            llttActive: {
                name: '调研文章',
                code: '3'
            },
            // 审判通报的tab切换
            sptbList: fdDataTable.sptbList,
            sptbActive: {
                name: '白皮书',
                code: '5'
            },
            // 法律资源的tab切换
            sfwjList: fdDataTable.sfwjList,
            sfwjActive: {
                name: '司法解释',
                code: '7'
            },
            // 域外司法的tab切换
            ywsfList: fdDataTable.ywsfList,
            ywsfActive: {
                name: '域外法律',
                code: '10'
            },
            // 海事仲裁的tab切换
            hszcList: fdDataTable.hszcList,
            hszcActive: {
                name: '仲裁简介',
                code: '15'
            },
            // 法院的tab切换
            fyList: fdDataTable.fyList,
            activeFy: 'zgrmfy'
        };
    },
    methods: {
        // 法院公告的tab切换的change事件
        changeFyggActive(code, item) {
            this.activeFygg = item;
            this.fyggTable = this.fyggData[code];
        },
        changeKyxxActive(code, item) {
            this.kyActive = item;
            this.cbkyTable = this.kyxxData[code];
        },
        changeFyjsActive(code, item) {
            this.fyjsActive = item;
            if (this.fyjsActive.code === '0') {
                this.initFyjj(this.fyjsActive.code);
            } else {
                this.initFyjj(this.fyxx[this.fyjsActive.code][0].code);
            }
        },
        changePmxxActive(code, item) {
            this.pmActive = item;
            this.cbplList = this.pmxxData[code];
        },
        // 海事案例的tab切换的change事件
        changeHsalActive(code, item) {
            this.hsalActive = item;
            this.hsalTable = this.hsalData[code];
        },
        // 理论探讨的tab切换的change事件
        changeLlttActive(code, item) {
            this.llttActive = item;
            this.llttTable = this.llttData[code];
        },
        // 审判通报的tab切换的change事件
        changeSptbActive(code, item) {
            this.sptbActive = item;
            this.sptbTable = this.sptbData[code];
        },
        // 法律资源的tab切换的change事件
        changeSfwjActive(code, item) {
            this.sfwjActive = item;
            this.sfwjTable = this.sfwjData[code];
        },
        // 域外司法的tab切换的change事件
        changeYwsfActive(code, item) {
            this.ywsfActive = item;
            this.ywsfTable = this.ywsfData[code];
        },
        // 海事仲裁的tab切换的change事件
        changeHszcActive(code, item) {
            this.hszcActive = item;
            this.hszcTable = this.hszcData[code];
        },
        // 法院的tab切换的change事件
        changeFyActive(code) {
            this.activeFy = code;
        },
        // 跳转到其他页面
        goToPage(path, query) {
            this.$router.push({path: path, query: query});
        },
        // 跳转到法院公告的页面详情
        goToGgxq(item) {
            const url = this.$router.resolve({path: '/xwzxDetail', query: {active: 'ssfw', bh: item.bh, fileType: 21}});
            window.open(url.href, '_blank');
        },
        // 跳转到新闻资讯的图片新闻详情
        goToXwzx(item) {
            const url = this.$router.resolve({path: '/xwzxDetail', query: {active: 'xwzx', bh: item.id, fileType: 23}});
            window.open(url.href, '_blank');
        },
        // 跳转学习新时代
        gotoXxxsd(item) {
            const url = this.$router.resolve({path: '/xwzxDetail', query: {active: this.active, bh: item.bh, fileType: 25}});
            window.open(url.href, '_blank');
        },
        // 跳转到海事案例的案例详情
        goToHsal(item) {
            const url = this.$router.resolve({path: '/lltt/dedail', query: {active: 'hsal', bh: item.bh, ejlb: item.ejlb}});
            window.open(url.href, '_blank');
        },
        // 跳转到理论探讨的案例详情
        goToLltt(item) {
            const url = this.$router.resolve({path: '/lltt/dedail', query: {active: 'lltt', bh: item.bh, ejlb: item.ejlb}});
            window.open(url.href, '_blank');
        },
        // 跳转到审判通报的案例详情
        goToSptb(item) {
            const url = this.$router.resolve({path: '/lltt/dedail', query: {active: 'sptb', bh: item.bh, ejlb: item.ejlb}});
            window.open(url.href, '_blank');
        },
        // 跳转到法律资源的详情
        goToSfwj(item) {
            const url = this.$router.resolve({path: '/lltt/dedail', query: {active: 'flzy', bh: item.bh, ejlb: item.ejlb}});
            window.open(url.href, '_blank');
        },
        // 跳转到域外司法的详情
        goToYwsf(item) {
            const url = this.$router.resolve({path: '/lltt/dedail', query: {active: 'ywsf', bh: item.bh, ejlb: item.ejlb}});
            window.open(url.href, '_blank');
        },
        // 跳转到海事仲裁的详情
        goToHszc(item) {
            const url = this.$router.resolve({path: '/lltt/dedail', query: {active: 'hszc', bh: item.bh, ejlb: item.ejlb}});
            window.open(url.href, '_blank');
        },
        // 跳转到扣押的详情
        goToKy(row) {
            const url = this.$router.resolve({path: 'kypm/kyxq', query: {active: 'kypm', tag:'ky', bh: row.bh, lx: '20'}});
            window.open(url.href, '_blank');
        },
        // 跳转到拍卖的详情
        goToPm(row) {
            const url = this.$router.resolve({path: '/kypm/xq', query: {active: 'kypm', tag:'pm', bh: row.bh, bdlb: row.bdlb, lx: '19'}});
            window.open(url.href, '_blank');
        }
    }
};
